module.exports = __webpack_public_path__ + "assets/img/MatrixBAIOS.b49e466c.png";